import Head from 'next/head';
import { title, baseBaseUrl, baseUrl } from '@constants';

const data = ({
  itemPaths,
  includesWebSite,
}: {
  itemPaths: string[];
  includesWebSite?: boolean;
}) => [
  ...(includesWebSite
    ? [
        {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '発注ラウンジ',
          description: title,
          url: `${baseUrl}`,
        },
      ]
    : []),
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: itemPaths.map((path, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      url: `${baseBaseUrl}${path}`,
    })),
  },
];

export const JsonLd: React.FC<{
  itemPaths: string[];
  includesWebSite?: boolean;
}> = ({ itemPaths, includesWebSite }) => (
  <Head>
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data({ itemPaths, includesWebSite })),
      }}
    />
  </Head>
);
